import React, { useState } from 'react';
import { Link } from 'gatsby';

import Transition from '../utils/transition';
import Logo from './logo';

const Header = () => {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);
  const openMenu = () => setOpen(true);

  return (
    <div className='py-6 px-4 sm:px-6 lg:px-8'>
      <nav className='flex items-center justify-between sm:h-10'>
        <div className='flex items-center flex-grow flex-shrink-0 lg:flex-grow-0'>
          <div className='flex items-center justify-between w-full md:w-auto'>
            <Link to='/' aria-label='Home'>
              <Logo />
            </Link>
            <div className='-mr-2 flex items-center md:hidden'>
              <button
                onClick={openMenu}
                type='button'
                className='inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out'
                id='main-menu'
                aria-label='Main menu'
                aria-haspopup='true'
              >
                <svg
                  className='h-6 w-6'
                  stroke='currentColor'
                  fill='none'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M4 6h16M4 12h16M4 18h16'
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className='hidden md:block md:ml-10 md:pr-4'>
          <Link
            to='/'
            className='ml-8 font-medium text-gray-500 hover:text-gray-900 transition duration-150 ease-in-out'
          >
            Why Praiser?
          </Link>
          <Link
            to='/pricing'
            className='ml-8 font-medium text-gray-500 hover:text-gray-900 transition duration-150 ease-in-out'
          >
            Pricing
          </Link>
          <Link
            to='/'
            className='ml-8 font-medium text-gray-500 hover:text-gray-900 transition duration-150 ease-in-out'
          >
            About
          </Link>
          <span className='ml-8 inline-flex rounded-md shadow-sm'>
            <Link
              to='/'
              className='whitespace-no-wrap inline-flex items-center justify-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150'
            >
              Sign up
            </Link>
          </span>
        </div>
      </nav>

      <Transition
        show={open}
        appear
        enter='transition ease-out duration-150 transform'
        enterFrom='opacity-0 scale-95'
        enterTo='opacity-100 scale-100'
        leave='transition ease-in duration-100 transform'
        leaveFrom='opacity-100 scale-100'
        leaveTo='opacity-0 scale-95'
      >
        <div className='absolute top-0 inset-x-0 p-2 origin-top-right md:hidden'>
          <div className='rounded-lg shadow-md'>
            <div
              className='rounded-lg bg-white shadow-xs overflow-hidden'
              role='menu'
              aria-orientation='vertical'
              aria-labelledby='main-menu'
            >
              <div className='px-5 pt-4 pb-2 flex items-center justify-between'>
                <div>
                  <Logo />
                </div>
                <div className='-mr-2'>
                  <button
                    onClick={closeMenu}
                    type='button'
                    className='inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 focus:text-gray-500 transition duration-150 ease-in-out'
                    aria-label='Close menu'
                  >
                    <svg
                      className='h-6 w-6'
                      stroke='currentColor'
                      fill='none'
                      viewBox='0 0 24 24'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M6 18L18 6M6 6l12 12'
                      />
                    </svg>
                  </button>
                </div>
              </div>
              <div className='px-2 pt-2 pb-3'>
                <Link
                  to='/'
                  className='block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out'
                  role='menuitem'
                >
                  Why Praiser?
                </Link>
                <Link
                  to='/pricing'
                  className='mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out'
                  role='menuitem'
                >
                  Pricing
                </Link>
                <Link
                  to='/'
                  className='mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50 focus:outline-none focus:text-gray-900 focus:bg-gray-50 transition duration-150 ease-in-out'
                  role='menuitem'
                >
                  About
                </Link>
              </div>
              <div>
                <Link
                  to='/'
                  className='block w-full px-5 py-3 text-center font-medium text-indigo-600 bg-gray-50 hover:bg-gray-100 hover:text-indigo-700 focus:outline-none focus:bg-gray-100 focus:text-indigo-700 transition duration-150 ease-in-out'
                  role='menuitem'
                >
                  Sign Up
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default Header;
